import { Gauge } from '@antv/g2plot';
import React, { useEffect, useRef } from 'react';

const PriceGauge = ({ initialBalance }) => {
  const containerRef = useRef(null);
  const gaugeRef = useRef(null);
  const maxBalance = 2500;

  useEffect(() => {
    if (!containerRef.current) return;

    const gauge = new Gauge(containerRef.current, {
      width: 220,
      height: 220,
      autoFit: true,
      appendPadding: [0, 0, 0, 0],
      percent: initialBalance / maxBalance,
      range: {
        ticks: [1, 2, 3, 4, 5, 6],
        color: ['l(0) 0:#F4664A 0.5:#FAAD14 1:#30BF78'],
      },
      indicator: {
        pointer: {
          style: {
            stroke: '#D0D0D0',
          },
        },
        pin: {
          style: {
            stroke: '#D0D0D0',
          },
        },
      },
      axis: {
        label: {
          formatter: (v) => Number(v * maxBalance),
          style: {
            fontSize: 12,
          },
        },
        subTickLine: {
          count: 5,
        },
      },
      statistic: {
        content: {
          formatter: () => `${initialBalance}`,
          style: {
            fontSize: '20px',
          },
        },
        title: {
          content: 'Chats Available',
          style: {
            fontSize: '12px',
            marginTop: '30px',
          },
        },
      },
    });
    console.log(initialBalance, maxBalance);
    

    gauge.render();
    gaugeRef.current = gauge;

    return () => {
      gauge.destroy();
    };
  }, [initialBalance]);

  return (
    <div ref={containerRef} style={{ 
      display: 'flex', 
      justifyContent: 'flex-start',
      width: '100%' ,
      height: '100%',
      paddingRight: '100px',
    }} />
  );
};

export default PriceGauge;